<template>
    <div class="frmkepviselet_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>

        <div class="frmkepviselet_itemcont" v-show="InitDone">
            <div class="frmkepviselet_itemcont_col1">
                <b>Körzet információk</b>
                <br><span class="frmkepviselet_itemlabel">Körzet neve:</span><span class="frmkepviselet_itemdata">{{Item.KorzetNev}}</span>
                <br><span class="frmkepviselet_itemlabel">Ir. szám:</span><span class="frmkepviselet_itemdata">{{Item.KorzetIrszam}}</span>
                <br><span class="frmkepviselet_itemlabel">Tagkódok:</span><span class="frmkepviselet_itemdata">{{Item.KorzetTagkod}}</span>

            </div>
            <div class="frmkepviselet_itemcont_col2">
                <b>Képviselet</b>
                <br><span class="frmkepviselet_itemlabel">Küldött:</span><span class="frmkepviselet_itemdata">{{Item.KuldottNev}}</span>
                <br><span class="frmkepviselet_itemlabel">Pótküldött:</span><span class="frmkepviselet_itemdata">{{Item.PotkuldottNev}}</span>
            </div>

        </div>




    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'


export default {
  name: 'frmkepviselet',
  components: {
      GrcText,
      GrcNum,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmKepviselet_",

          InitDone:false,  

          Item: { KorzetNev:"", KorzetIrszam:"", KorzetTagkod:"", KuldottNev:"", PotkuldottNev:"" },

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmKepviselet", pCompName);
    },

    SetLang()
    {
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.Item = Q.RESULT[0];

        this.InitDone = true;

      },

    async ShowLoginError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


